// Flat, minimal line icons (no emoji). Inherit color via currentColor.
type P = { className?: string };
const base = (className?: string) => `h-5 w-5 ${className ?? ''}`;

export function IconBack({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

export function IconTrash({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
    </svg>
  );
}

export function IconLayers({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M3 13l9 5 9-5" />
    </svg>
  );
}

// Satellite count indicator — standard "satellite dish" glyph (Lucide).
export function IconSatellite({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 10a7.31 7.31 0 0 0 10 10Z" />
      <path d="m9 15 3-3" />
      <path d="M17 13a6 6 0 0 0-6-6" />
      <path d="M21 13A10 10 0 0 0 11 3" />
    </svg>
  );
}

// Locate / center-on-me crosshair (Lucide "locate").
export function IconLocate({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="2" x2="5" y1="12" y2="12" />
      <line x1="19" x2="22" y1="12" y2="12" />
      <line x1="12" x2="12" y1="2" y2="5" />
      <line x1="12" x2="12" y1="19" y2="22" />
      <circle cx="12" cy="12" r="7" />
    </svg>
  );
}

// Folded map (vector basemap).
export function IconMap({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
      <path d="M9 4v14M15 6v14" />
    </svg>
  );
}

// Globe / satellite imagery (raster basemap).
export function IconGlobe({ className }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={base(className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
    </svg>
  );
}
